<template>
  <v-layout row wrap pa-4 ma-4 class="profile-politica">
    <v-flex xs12>
      <div v-html="text"></div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';

export default {
  name: 'profile-politica',
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      errors: [],
      loaded: false,
      text: ''
    };
  },
  mounted() {
    this.getPrivacypolicy();
  },
  computed: {
    region() {
      return this.$store.getters.profile.region;
    }
  },
  methods: {
    async getPrivacypolicy() {
      var flag = this.$store.getters.profile.region;

      await axios
        .get(`/api/privacypolicy/${flag}/web`)
        .then(response => {
          this.text = response.data;
          this.loaded = true;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          // console.error(e)
          this.errors.push(e);
          this.loaded = true;
        });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/_variables';

.profile-politica {
  h3 {
    margin-bottom: 15px;
  }
}

.PerfilPolitica {
  main.content {
    min-height: 100%;
  }
}
</style>
